// extracted by mini-css-extract-plugin
module.exports = {"container":"__4QZR_PSl","wrapper":"hMix6Q0E","content":"znaQNUIM","title":"jbMWHuf8"};